import { RefObject, useEffect, useMemo, useState } from 'react';

import useTrackBoundingClient from './use-track-bounding-client';

type TUseIsClippedProps = {
  ref: RefObject<HTMLElement | null> | null;
};

const useIsClipped = ({ ref }: TUseIsClippedProps) => {
  const [reTrack, setReTrack] = useState(0);
  const boundingRect = useTrackBoundingClient({
    ref: ref?.current || null,
    open: true,
    rerunCounter: reTrack,
  });

  useEffect(() => {
    if (!ref?.current) return;

    setReTrack((prev) => prev + 1);
    // retrigger when we have a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref?.current]);

  return useMemo(() => {
    const el = ref?.current;
    if (!el) return false;
    const parentEl = el.parentElement;
    if (!parentEl) return false;

    const styles = window.getComputedStyle(el);
    if (styles.textOverflow === 'clip') {
      // equal to is important here, because when in "clip" the child is never greater than the parent, becasue it's clipped
      if (el.scrollWidth === parentEl.offsetWidth) return true;
    }
    return (el?.scrollWidth || 0) > (parentEl?.offsetWidth || 0);
    // always retrigger on width change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boundingRect?.width]);
};

export default useIsClipped;
